import _ from "lodash";
import moment from "moment-timezone";
import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { DateRangePicker } from "react-dates";
import SimpleDropdown from "../../../../components/dropdowns/simple-dropdown";
import PopoverFilterWrapper from "../../../../components/filter/popover-filter";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { campaignChannelsOptions, campaignTypeOptions } from "../../../campaign-live-status-v2/constants";

export default function CampaignSummaryReportFilter(props) {
  const [channel, setChannel] = useState({});
  const [type, setType] = useState({});
  const [fromDate, setFromDate] = useState(
    moment()
      .subtract(7, "days")
      .valueOf(),
  );
  const [toDate, setToDate] = useState(moment().valueOf());
  const [focusedInput, setFocusedInput] = useState("");

  useEffect(() => {
    if (!_.isEmpty(props.filterValue)) {
      const { type, fromDate, toDate } = props.filterValue;
      setFromDate(fromDate);
      setToDate(toDate);
      const typeFind = campaignTypeOptions.find((a) => a.value === type);
      setType(typeFind);
      const channelFind = campaignChannelsOptions.find((a) => a.value === props.filterValue.channel);
      setChannel(channelFind);
    }

  }, [props.filterValue]);

  const handleApplyFilter = () => {
    const payload = {
      type: type.value,
      fromDate: fromDate,
      toDate: toDate,
      channel: channel.value,
    };
    props.handleApplyFilter(payload);
  };

  const isOutsideRange = (day) => {
    const _startDate = fromDate ? moment(fromDate) : moment();
    return focusedInput === "endDate" && (day.isBefore(_startDate) || day.isAfter(_startDate.clone().add(2, "months")));
  };
  return (
    <PopoverFilterWrapper
      show={props.show}
      setShow={props.setShow}
      label={"Filter"}
      onSaveClick={handleApplyFilter}
      onCancelClick={props.handleCancelFilter}
      showCancel={true}
      showSave={true}
      saveButtonText={"Apply"}
      cancelButtonText={"Cancel"}
    >
      <Form className="w-350px">
        <Form.Group>
          <Form.Label className="fw-bold">Channel</Form.Label>
          <SimpleDropdown value={channel} label={"Channel"} options={campaignChannelsOptions} handleSelect={setChannel} />
        </Form.Group>
        <Form.Group>
          <Form.Label className="fw-bold">Type</Form.Label>
          <SimpleDropdown value={type} label={"Type"} options={campaignTypeOptions} handleSelect={setType} />
        </Form.Group>
        <Form.Group>
          <Form.Label className="fw-bold">Duration</Form.Label>
          <div>
            <DateRangePicker
              startDate={fromDate ? moment(fromDate) : null}
              startDateId="fromdate"
              endDate={toDate ? moment(toDate) : null}
              endDateId="enddate"
              onDatesChange={({ startDate, endDate }) => {
                const _startDate = startDate ? moment(startDate).startOf('day').valueOf() : null;
                const _endDate = endDate ? moment(endDate).endOf('day').valueOf() : null;
                setFromDate(_startDate);
                setToDate(_endDate);
              }}
              displayFormat={"YYYY-MM-DD"}
              small={true}
              isOutsideRange={isOutsideRange}
              focusedInput={focusedInput}
              onFocusChange={(focusedInput) => {
                setFocusedInput(focusedInput);
              }}
            />
          </div>
        </Form.Group>
      </Form>
    </PopoverFilterWrapper>
  );
}
